import React from 'react';

const REDES = [
    {
        id: 'instagram',
        nombre: 'Instagram',
        usuario: '@reditmex',
        icono: 'fab fa-instagram',
        color: 'linear-gradient(135deg, #f58529 0%, #dd2a7b 50%, #8134af 100%)',
        href: 'https://www.instagram.com/reditmex/',
        accion: 'Seguir',
        descripcion: 'Fotos, historias y novedades de Red Itmex.',
    },
    {
        id: 'facebook',
        nombre: 'Facebook',
        usuario: 'itmexoficial',
        icono: 'fab fa-facebook-f',
        color: '#1877f2',
        href: 'https://www.facebook.com/itmexoficial',
        accion: 'Seguir',
        descripcion: 'Noticias, promociones y avisos de Red Itmex.',
    },
    {
        id: 'youtube',
        nombre: 'YouTube',
        usuario: 'Red Itmex',
        icono: 'fab fa-youtube',
        color: '#ff0000',
        href: 'https://www.youtube.com/channel/UC6Sirelw0bYpaT4VktsK19A',
        accion: 'Suscribirme',
        descripcion: 'Videos, podcasts y contenido original, gratis.',
    },
    {
        id: 'spotify',
        nombre: 'Spotify',
        usuario: 'Podcast Red Itmex',
        icono: 'fab fa-spotify',
        color: '#1db954',
        href: 'https://open.spotify.com/show/56dQAu73j4a0QaLRO44oa7',
        accion: 'Escuchar',
        descripcion: 'Historias, retos y aprendizajes de las personas de nuestra comunidad.',
    },
];

const Redes = () => (
    <section className="redesItmex">
        <div className="redesItmex-header">
            <h2 className="tituloItmex tituloItmex--chico">Síguenos en nuestras plataformas</h2>
            <p>Contenido original y podcasts gratuitos.</p>
        </div>

        <div className="redesItmex-grid">
            {REDES.map(red => (
                <a key={red.id} className="redesItmex-card" href={red.href} target="_blank" rel="noopener noreferrer">
                    <div className="redesItmex-figura">
                        <img src={`/assets/img/redes/${red.id}.png`} alt="" loading="lazy" />
                    </div>
                    <div className="redesItmex-info">
                        <span className="redesItmex-icono" style={{ background: red.color }}><i className={red.icono}></i></span>
                        <span className="redesItmex-nombre">
                            <b>{red.nombre}</b>
                            <span>{red.usuario}</span>
                        </span>
                        <span className="redesItmex-flecha" aria-label={red.accion}><i className="fas fa-arrow-right"></i></span>
                    </div>
                    <p className="redesItmex-descripcion">{red.descripcion}</p>
                </a>
            ))}
        </div>

        <p className="redesItmex-leyenda">Itmex ofrece únicamente el servicio de internet fijo residencial o empresarial. No incluye servicios de plataforma digitales, de streaming o videojuegos.</p>
    </section>
);

export default Redes;
